var _path, _path2, _circle, _rect, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg30Min(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6022 2.27257C18.6022 1.01746 19.6197 0 20.8748 0C22.1299 0 23.1474 1.01746 23.1474 2.27257V2.95044C32.3446 4.0711 39.4688 11.9069 39.4688 21.4067C39.4688 31.6758 31.1441 40.0005 20.875 40.0005C10.606 40.0005 2.28125 31.6758 2.28125 21.4067C2.28125 17.0583 3.77399 13.0584 6.27499 9.89172L5.94177 9.58264C5.02157 8.7291 4.96753 7.2912 5.82107 6.371C6.6746 5.4508 8.1125 5.39676 9.0327 6.2503L9.50792 6.69109C12.086 4.69673 15.2025 3.36482 18.6022 2.95049V2.27257Z",
    fill: "#272727"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8754 4.86727C25.2589 4.86727 29.4628 6.60858 32.5624 9.70814C35.6619 12.8077 37.4032 17.0116 37.4032 21.3951C37.4032 25.7785 35.6619 29.9824 32.5624 33.082C29.4628 36.1815 25.2589 37.9228 20.8755 37.9229L20.8754 21.3951L20.8754 4.86727Z",
    fill: "#C93F37"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.8749,
    cy: 21.3956,
    r: 4.13195,
    transform: "rotate(90 20.8749 21.3956)",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.9077,
    y: 35.3159,
    width: 2.06597,
    height: 12.3575,
    rx: 1.03299,
    transform: "rotate(-180 21.9077 35.3159)",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.8751,
    cy: 21.3956,
    r: 1.56259,
    fill: "#272727"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg30Min);
export default __webpack_public_path__ + "static/media/30min.210c4d33923c4bbc60a415151762a908.svg";
export { ForwardRef as ReactComponent };